<!--
 * @Description: 访客计划 -- 新增页面
 * @Author: mdb
 * @Date: 2022-07-19 11:12:06
 * @LastEditTime: 2023-03-09 10:31:06
 * @LastEditors: cxh
-->
<template>
  <CosLayoutMain>
    <template #content>
      <VisitorProgramForm
        ref="visitorProgramFormRef"
        :title="t('common.visitorTabs')"
        type="add"
        v-model:value="dataForm"
        :saleChanceRefId="querySaleChanceRefId"
        @update:value="fetch"
      />
    </template>
    <template #footer>
      <a-button @click="goBack()">{{ t('btn.cancel') }}</a-button>
      <a-button :loading="loading" @click="handleReset()">{{ t('btn.reset') }}</a-button>
      <a-button v-permission="'ofbu_visitor_add_btn'" type="primary" :loading="loading" @click="handleSubmit()"
        >{{ t('btn.save') }}</a-button
      >
    </template>
  </CosLayoutMain>
</template>

<script setup lang="ts">
import { ref, reactive, toRaw, computed } from 'vue'
import { useRoute } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import { goBack } from '@/hooks/cosRouter'
import VisitorProgramForm from '../components/VisitorProgramForm.vue'
import { visitorProgramCreateOrUpdate } from '@/api/overseasSales/followUpManage'
import type { FbuVisitorProgramEditParams } from '@/typings/api/followUpManage'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const route = useRoute()

const dataForm = reactive<FbuVisitorProgramEditParams>({
  remindType: 1
})

// 监听是否是从跟进记录页面跳转过来
const querySaleChanceRefId = computed(() => route.query.saleChanceRefId as string)

const fetch = (val: any) => {
  Object.assign(dataForm, val)
}

const visitorProgramFormRef = ref()
const handleReset = () => {
  visitorProgramFormRef.value?.resetFields()
}
const loading = ref(false)
const handleSubmit = () => {
  visitorProgramFormRef.value?.validate().then(() => {
    loading.value = true
    const params = toRaw(dataForm)
    visitorProgramCreateOrUpdate(params)
      .then(() => {
        message.success(t('tips.addSuccess'))
        visitorProgramFormRef.value?.resetFields()
        goBack()
      })
      .finally(() => {
        loading.value = false
      })
  })
}
</script>
<script lang="ts">
export default { name: 'DcCosOFbuVisitorProgramAdd' }
</script>

<style scoped></style>
